<script lang="ts">
  import ProjectGrid from "../components/content/project/ProjectGrid.svelte";
</script>

<div class="app-grid inside-root">
  <ProjectGrid />
</div>
